import { render, staticRenderFns } from "./AddCourseArticle.vue?vue&type=template&id=a0af29be&scoped=true&"
import script from "./AddCourseArticle.vue?vue&type=script&lang=js&"
export * from "./AddCourseArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddCourseArticle.vue?vue&type=style&index=0&id=a0af29be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0af29be",
  null
  
)

export default component.exports